import { Cascader } from 'antd';
import React, { useImperativeHandle, useState } from 'react';
import styles from './index.module.less';

interface IStateTransfer {
  onChange: Function;
}
export default React.forwardRef((props: IStateTransfer, ref) => {
  const [selectedValue, setSelectedValue] = useState<string[]>([]);

  const _setSelectValue = (ids: string[]) => {
    setSelectedValue(ids);
  };
  const clear = () => {
    setSelectedValue([]);
    props.onChange('');
  };

  useImperativeHandle(ref, () => ({
    clear,
    _setSelectValue,
  }));

  const options = [
    {
      value: '',
      label: '全部',
    },
    // {
    //   value: 'transfered',
    //   label: '转换成功',
    // },
    {
      value: 'osOnline',
      label: '上架',
    },
    {
      value: 'osOffline',
      label: '下架',
    },
    {
      value: 'transfering',
      label: '转换中',
    },
    {
      value: 'fail',
      label: '转换失败',
    },
    {
      value: 'invalid',
      label: '应用异常',
    },
  ];
  const onChange = (ids: any) => {
    let tagCode = '';
    if (ids && ids.length > 0) {
      tagCode = ids.slice(-1)[0];
    }
    console.log('tagCode', tagCode);
    setSelectedValue(ids);
    props.onChange(tagCode, ids);
  };
  const dropdownRender = (menus: React.ReactNode) => <div>{menus}</div>;

  return (
    <>
      <div>
        <label className="text-grey-5 ml8">状态：</label>
        <Cascader
          value={selectedValue}
          bordered={false}
          options={options}
          changeOnSelect={true}
          placeholder="全部"
          style={{ maxWidth: 120 }}
          onChange={onChange}
          dropdownRender={dropdownRender}
          dropdownClassName={styles.transferDropdown}
        />
      </div>
    </>
  );
});
